import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "PokerPowerPathWidget" */ './PokerPowerPathWidget'),
  modules: ['./PokerPowerPathWidget'],
  loading: () => <div />
});

export default LoadableWidget;
